import { createSelector } from 'reselect';

const baseSelector = state => (state.referral.callback);

export const requestCallbackSelector = createSelector(
  baseSelector,
  ({
    isLoading,
    isCoinDataLoading,
    coinSharedData,
    coinSharedDataError,
    rcbSource,
  }) => ({
    isLoading,
    isCoinDataLoading,
    coinSharedData,
    coinSharedDataError,
    rcbSource,
  }),
);
